import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from 'styled-components/macro';
import RangeSlider from 'app/components/Slider';
import { FilterProps } from 'app/components/FilterCard';
import { AmountInput } from 'app/components/FilterCard/MainFilters/common/AmountInput';
import { Label } from 'app/components/FilterCard/MoreFilters/common/FilterSelectStyles';
import { MainFiltersCard } from 'app/components/FilterCard/MainFilters/common/MainFilterCard';
import { useRecoilValue } from 'recoil';
import { transactionTypeAtom } from 'app/state/recoil/atoms';

export const TransactionValueFilter = (props: FilterProps) => {
  const transactionType = useRecoilValue(transactionTypeAtom);
  const [valueRange, setValueRange] = React.useState<number[]>(
    getInitialRange()
  );

  const handleChange = (event: any, newValue: number | number[]) => {
    setValueRange(newValue as number[]);
  };

  function getInitialRange(): number[] {
    if (props.selectedFilters.transactionvalue.length > 0) {
      return formatValues(
        props.selectedFilters.transactionvalue,
        1000000,
        true
      );
    }
    return [0, 1600];
  }

  function formatValues(range: any, multiplier = 1000000, revert = false) {
    let budgetMin;
    let budgetMax;
    if (revert) {
      budgetMin = range[0] / multiplier;
      budgetMax = range[1] / multiplier;
    } else {
      budgetMin = range[0] * multiplier;
      budgetMax = range[1] * multiplier;
    }
    return [budgetMin, budgetMax];
  }

  React.useEffect(() => {
    props.setSelectedOptions(formatValues(valueRange, 1000000));
  }, [valueRange]);

  React.useEffect(() => {
    if (props.selectedOptions <= 0) {
      setValueRange([0, 1600]);
    }
  }, [props.selectedOptions]);

  const handleChangeAmountInputFrom = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValueRange([parseInt(event.target.value, 10), valueRange[1]]);
  };

  const handleChangeAmountInputTo = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValueRange([valueRange[0], parseInt(event.target.value, 10)]);
  };

  return (
    <MainFiltersCard
      title={transactionType.name}
      {...props}
      removeTopControls
      dontDisplaySelected
    >
      <Grid item container lg={12}>
        {/* USE THIS WHEN WE DECIDE WHAT TRANSACTION TYPES TO FILTER ON */}
        {/* <Grid
          item
          lg={12}
          css={css`
            margin-bottom: 16px;
          `}
        >
          <Label>Budget or transaction type</Label>
          <FilterSelect
            isSingle
            defaultValue={{ value: 'Disbursed', label: 'Disbursed' }}
            options={[
              { value: 'All', label: 'All' },
              { value: 'Disbursed', label: 'Disbursed' },
            ]}
            placeholder="All"
          />
        </Grid> */}
        <Grid item container>
          <Grid
            item
            lg={6}
            css={css`
              margin-bottom: 68px;
            `}
          >
            <Label>US$ Amount (from)</Label>
            <AmountInput
              left
              value={valueRange[0]}
              endAdornmentText="US$ M"
              handleChange={handleChangeAmountInputFrom}
            />
          </Grid>
          <Grid
            item
            lg={6}
            css={css`
              margin-bottom: 30px;
            `}
          >
            <Label marginLeft={7.5}>US$ Amount (to)</Label>
            <AmountInput
              left={false}
              value={valueRange[1]}
              endAdornmentText="US$ M"
              handleChange={handleChangeAmountInputTo}
            />
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          css={css`
            margin-bottom: 24px;
          `}
        >
          <RangeSlider value={valueRange} handleChange={handleChange} />
        </Grid>
      </Grid>
    </MainFiltersCard>
  );
};
